import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'initials',
  standalone: true,
})
export class InitialsPipe implements PipeTransform {
  transform(name: string): string {
    if(!name){
        return '';
      }
      const firstName = name.split(' ')[0];
      const lastName = name.split(' ')[1];

      return `${firstName?.charAt(0)?.toUpperCase() ?? ''}${lastName?.charAt(0)?.toUpperCase() ?? ''}`;
  
    }
  }

